import {StatusCode} from '../types/statusCode';

export function getCodeWithArchivedStatus(code: StatusCode, archived?: boolean): StatusCode {
  return archived ? 'ARCHIVED' : code;
}
